import React, {useEffect} from "react";
import "./styles.css";


const GameResultModal = ({
                             avatar,
                             multiplayerGameResults,
                             handlePlayAgain,
                             userId,
                             handleExitAfterResults,
                             setIsGameWon,
                         }) => {
    const showExitButton = process.env.REACT_APP_SHOW_MULTIPLAYER_RESULT_EXIT_BUTTON === "true";
    const userParticipant = multiplayerGameResults.find(
        (participant) => participant.user_id === userId
    );
    const otherParticipants = multiplayerGameResults.sort((a, b) => a.rank - b.rank);


    const isGameWon = userParticipant?.rank === 1;

    useEffect(() => {
        setIsGameWon(isGameWon);
    }, [isGameWon, setIsGameWon]);
    return (
        <div
            className="top-[200px] absolute left-1/2 -translate-x-1/2 flex flex-col items-center font-satoshi rounded-xl w-[90vw] md:w-[50vw] min-w-[250px] max-w-[500px] mx-auto z-[999999999999999999999] ">
            <div
                style={{width: "fit-content"}}
                className="multiplayer-modal-wrapper w-[100%]"
            >
                <div
                    className="font-rubik flex flex-col items-center justify-center pb-0 rounded-lg relative bg-white">
                    {isGameWon && (
                        <img
                            draggable={false}
                            src="/images/crown.png"
                            alt="Crown"
                            className="absolute top-0 transform -translate-y-60 w-18"
                        />
                    )}

                    {isGameWon ? (
                        <div>
                            <img
                                draggable={false}
                                src="/images/win-banner.svg"
                                className="w-[80vw] absolute inset-0 scale-125 transform -translate-y-10 left-1/2 -translate-x-1/2"
                                alt="Win Banner"
                            />
                        </div>
                    ) : (
                        <div>
                            <img
                                draggable={false}
                                src="/images/lost-banner.svg"
                                className="w-[80vw] absolute inset-0 scale-125 transform -translate-y-10 left-1/2 -translate-x-1/2"
                                alt="Lost Banner"
                            />
                        </div>
                    )}

                    <div className="relative flex justify-center items-center w-72 h-32 md:h-40 md:pt-6 pt-3">
                        <img
                            draggable={false}
                            src="/images/sun.png"
                            alt="Sun Background"
                            className="absolute w-52 h-52 slow-spin"
                        />
                        <img
                            draggable={false}
                            src={avatar || "images/default-avatar.png"}
                            alt="Avatar"
                            className="w-20 h-20 md:w-28 md:h-28 rounded-full border-4 border-white relative z-10"
                        />
                    </div>

                    <div className={`flex justify-center my-1 mx-4 text-xl px-2 w-[100%] ${showExitButton ? "gap-2" : ""}`}>
                        {showExitButton && (
                        <button
                            className={`focus:outline-none bg-white p-2 w-[100%] rounded-2xl font-extrabold border border-b-4 transition ${
                                isGameWon
                                    ? "text-yellow-500 border-yellow-600 hover:bg-gray-300"
                                    : "text-red-500 border-red-500 hover:bg-gray-300"
                            }`}
                            onClick={handleExitAfterResults}
                        >
                            EXIT
                        </button>
                        )}
                        <button
                            className={`focus:outline-none p-2 w-[100%] rounded-2xl font-extrabold border border-b-4 transition ${
                                isGameWon
                                    ? "bg-yellow-500 text-white border-yellow-600 hover:bg-yellow-600"
                                    : "bg-red-400 text-white border-red-500 hover:bg-red-500"
                            }`}
                            onClick={handlePlayAgain}
                        >
                            PLAY AGAIN
                        </button>
                    </div>
                    <div
                        className={`w-[100%] pt-4 px-4 ${
                            isGameWon ? "text-yellow-500" : "text-red-500"
                        }`}
                    >
                        {otherParticipants
                            .map((participant) => (
                                <div
                                    className={
                                        "flex flex-row items-center justify-between w-[100%] pb-2"
                                    }
                                    key={participant.user_id}
                                >
                                    <div
                                        className={"flex flex-row items-center justify-between gap-2"}
                                    >
                                        <img
                                            alt={"img"}
                                            draggable={false}
                                            src={participant.avatar}
                                            className={"h-[40px] w-[40px] rounded-full"}
                                        />
                                        <div className={"flex flex-col"}>
                                            {participant.rank === 1 && (
                                                <div>
                                                    <img
                                                        draggable={false}
                                                        src={"/images/winner.png"}
                                                        className={"w-[80px] md:w-[100px]"}
                                                    />
                                                </div>
                                            )}
                                            <span className={"md:text-lg font-semibold"}>
                      {participant.name}
                    </span>

                                        </div>
                                    </div>

                                </div>
                            ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default GameResultModal;